var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VSelect',{attrs:{"value":_vm.templateType,"items":_vm.getTemplateTypes,"clearable":"","label":_vm.$t('forms.labels.workOrderTemplate.type'),"required":true,"dense":""},on:{"input":_vm.updateData}})}
var staticRenderFns = []

export { render, staticRenderFns }